// Components==============
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import { getDate } from 'utilities/getDate';
import Card from './Card';
import './Reflection.module.scss';
// =========================

export default function Reflection() {
  const reflections = useRedux((state) =>
    state.reflection?.entities.allIds
      .map((id) => state.reflection?.entities.byId[id])
      .filter(
        (r) =>
          r?.for_user?.id === state.authentication?.user?.id && r?.note?.[0]
      )
      // Project still exists
      .filter(
        (r) =>
          !!state.project?.entities.byId?.[r?.project_process?.project?.id || 0]
      )
      ?.sort((a, b) => getDate(b?.updated_at) - getDate(a?.updated_at))
  );

  const translate = useTranslate();

  const card1 = reflections?.[0];
  const card2 = reflections?.[1];

  return (
    <div styleName={`${!card1 && !card2 ? 'placeholder' : ''} box `}>
      <div styleName="wrapper">
        {card1 && <Card item={card1} first={!!card2} />}
        {card2 && <Card item={card2} />}
        {!card1 && !card2 && <Card placeholder />}
        <h3>{translate('reflection.reflections-from-others')}</h3>
      </div>
    </div>
  );
}
